import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FiMail, FiHome } from "react-icons/fi";
import { FaArrowRight } from "react-icons/fa";
import api from "../services/api";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail]     = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setMessage("Please enter your email."); return; }
    try {
      setLoading(true);
      setMessage("");
      const res = await api.post("/auth/forgot-password", { email });
      if (res.data.success) {
        setMessage("Password reset link generated successfully.");
        window.location.href = `/reset-password/${res.data.data.resetToken}`;
      }
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F5EF] flex items-center justify-center px-6 overflow-hidden">

      {/* Background */}
      <div className="absolute inset-0">
        <img src="/assets/image 25.jpeg" alt="" className="w-full h-full object-cover scale-110 opacity-[0.74]"/>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(242,154,12,0.16),transparent_35%)]"/>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_bottom_right,rgba(255,180,80,0.12),transparent_35%)]"/>
      </div>

      {/* Home button */}
      <motion.button type="button" onClick={() => navigate('/')}
        whileHover={{ y:-2, background:'rgba(255,255,255,0.22)', color:'#fff' }} whileTap={{ scale:0.95 }}
        className="absolute top-5 left-5 z-20 flex items-center gap-2 rounded-full border cursor-pointer"
        style={{ background:'rgba(255,255,255,0.14)', border:'1px solid rgba(255,255,255,0.22)', padding:'8px 16px', fontSize:12, fontWeight:600, color:'rgba(255,255,255,0.75)', fontFamily:"'Inter',sans-serif", backdropFilter:'blur(12px)', transition:'all 0.25s cubic-bezier(0.25,1,0.5,1)' }}>
        <FiHome size={15} style={{ color:'inherit' }}/> Home
      </motion.button>

      {/* Card */}
      <motion.div initial={{ opacity:0, y:30 }} animate={{ opacity:1, y:0 }} transition={{ duration:0.8 }}
        className="relative w-full max-w-[480px] rounded-[36px] bg-white/55 backdrop-blur-[40px] border-white/40 shadow-[0_60px_180px_rgba(242,154,12,0.16)] p-8 md:p-10">

        {/* Header */}
        <div className="mt-8">
          <p className="text-[#F29A0C] text-[11px] tracking-[4px] uppercase font-semibold">PASSWORD RECOVERY</p>
          <h1 className="text-[44px] leading-[0.92] tracking-[4px] font-semibold text-[#111111] mt-4" style={{ fontFamily:"Poppins" }}>
            Forgot<br/>Password
          </h1>
          <p className="text-[#666666] text-[15px] leading-[30px] mt-5">
            Enter your registered email address and we'll send you a password reset link.
          </p>
        </div>

        {/* Message */}
        {message && (
          <div className="mt-6 rounded-[18px] border bg-white/70 backdrop-blur-xl border-white/50 px-5 py-4 text-[#A15C07] text-sm">
            {message}
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="mt-10">
          <div className="flex group relative items-center h-[66px] rounded-[22px] border border-white/60 bg-white/80 backdrop-blur-xl px-5 transition-all duration-300 focus-within:border-[#F29A0C] focus-within:shadow-[0_10px_40px_rgba(242,154,12,0.10)]">
            <FiMail className="text-[#F29A0C]"/>
            <input type="email" placeholder="Email Address" value={email} onChange={e => setEmail(e.target.value)}
              className="w-full h-full bg-transparent outline-none border-none px-4 text-[#111111]"/>
          </div>

          <motion.button whileHover={{ y:-2 }} whileTap={{ scale:0.98 }} type="submit"
            className="w-full h-[70px] rounded-[22px] mt-6 bg-gradient-to-r from-[#F29A0C] via-[#FF9500] to-[#FF8400] text-white font-semibold flex items-center justify-center gap-3 shadow-[0_20px_60px_rgba(242,154,12,0.18)]">
            {loading ? "Sending..." : "Send Reset Link"}<FaArrowRight/>
          </motion.button>
        </form>

        {/* Footer */}
        <p className="text-center text-[#666666] text-[15px] mt-8">
          Back to <Link to="/login" className="text-[#F29A0C] font-semibold ml-2">Login</Link>
        </p>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;